import { useEffect, useState, useMemo } from 'react';
import { Chip } from '@mui/material';
import { CatalogService } from '../../../../service/catalogService';

const useCatalogFrameColumns = () => {
    const [brands, setBrands] = useState([]);
    const [shapes, setShapes] = useState([]);
    const [materials, setMaterials] = useState([]);

    useEffect(() => {
        // Fetch filter options
        const fetchFilterOptions = async () => {
            try {
                const [brandsResponse, shapesResponse, materialsResponse] = await Promise.all([
                    CatalogService.getCatalogBrandsFilter(),
                    CatalogService.getFrameShapesFilter(),
                    CatalogService.getFrameMaterialsFilter()
                ]);

                // Process brands
                if (brandsResponse.code === 0) {
                    const brandOptions = brandsResponse.data.map(brand => ({
                        value: brand.id,
                        label: brand.name
                    }));
                    setBrands(brandOptions);
                }

                // Process shapes
                if (shapesResponse.code === 0) {
                    const shapeOptions = shapesResponse.data.map(shape => ({
                        value: shape.id,
                        label: shape.name
                    }));
                    setShapes(shapeOptions);
                }

                // Process materials
                if (materialsResponse.code === 0) {
                    const materialOptions = materialsResponse.data.map(material => ({
                        value: material.id,
                        label: material.name
                    }));
                    setMaterials(materialOptions);
                }
            } catch (error) {
                console.error('Error fetching catalog filter options:', error);
            }
        };

        fetchFilterOptions();
    }, []);

    return useMemo(() => [
        {
            id: 'brand',
            Header: 'Brand',
            accessor: 'brand.name',
            enableFilter: true,
            type: 'enum',
            filterOptions: brands
        },
        {
            id: 'modelNumber',
            Header: 'Model',
            accessor: 'frame.modelNumber',
            enableFilter: true,
            type: 'text'
        },
        // {
        //     id: 'upc',
        //     Header: 'UPC',
        //     accessor: 'frame.upcOrEan',
        //     enableFilter: true,
        //     type: 'text'
        // },
        {
            id: 'shape',
            Header: 'Shape',
            accessor: 'frame.shape.name',
            enableFilter: true,
            type: 'enum',
            filterOptions: shapes
        },
        // {
        //     id: 'material',
        //     Header: 'Material',
        //     accessor: 'frame.material.name',
        //     enableFilter: true,
        //     type: 'enum',
        //     filterOptions: materials
        // },
        // {
        //     id: 'gender',
        //     Header: 'Gender',
        //     accessor: 'frame.gender',
        //     Cell: ({ value }) => value ? <Chip label={value} size="small" /> : null
        // },
        {
            id: 'frameType',
            Header: 'Type',
            accessor: 'frame.frameType'
        },
        {
            id: 'color',
            Header: 'Color',
            accessor: 'frame.colorName'
        },
        {
            id: 'a',
            Header: 'A',
            accessor: 'frame.a',
            enableFilter: true,
            type: 'number',
            Cell: ({ value }) => value ? `${value}mm` : ''
        },
        {
            id: 'b',
            Header: 'B',
            accessor: 'frame.b',
            enableFilter: true,
            type: 'number',
            Cell: ({ value }) => value ? `${value}mm` : ''
        },
        {
            id: 'dbl',
            Header: 'DBL',
            accessor: 'frame.dbl',
            enableFilter: true,
            type: 'number',
            Cell: ({ value }) => value ? `${value}mm` : ''
        },
        {
            id: 'temple',
            Header: 'Temple',
            accessor: 'frame.temple',
            enableFilter: true,
            type: 'number',
            Cell: ({ value }) => value ? `${value}mm` : ''
        }
    ], [brands, shapes, materials]);
};

export default useCatalogFrameColumns;
